import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export type ProduccionProducto = {
  idProducto: number;
  codigo: string;
  producto: string;
  descripcion: string;
  idReceta: number;
  seProduce: boolean;
  costo: number;
  precioVenta: number;
  stock: number;
};

export type ProduccionProductoPage = {
  items: ProduccionProducto[];
  total: number;
  page: number;
  pageSize: number;
};

export type ProduccionInsumo = {
  idProducto: number;
  codigo?: string;
  producto: string;
  cantidad: number;
  cantidadUnitario: number;
  cantidadTotal: number;
  costo: number;
  observacion?: string;
};

export type ConfirmarProduccionRequest = {
  idLocal: number;
  idProducto: number;
  producto: string;
  cantidad: number;
  costoPorUnidad: number;
  actualizarCostoProducto: boolean;
  insumos: ProduccionInsumo[];
};

const headers = (user: UserPayload) => ({
  "Content-Type": "application/json",
  "Authorization": "Bearer " + user.token,
});

export async function fetchGetProductosProduccion(
  idLocal: string | undefined,
  user: UserPayload,
  page: number,
  pageSize: number,
  search: string,
  soloConReceta: boolean,
  signal?: AbortSignal
): Promise<ProduccionProductoPage> {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    soloConReceta: String(soloConReceta),
  });
  if (search.trim()) {
    params.set("search", search.trim());
  }

  const response = await fetch(`${URLAPI}/Produccion/Productos/${idLocal}?${params.toString()}`, {
    method: "GET",
    signal,
    headers: { "Authorization": "Bearer " + user.token },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const data = await response.json();
  return {
    items: data.items ?? data.Items ?? [],
    total: data.total ?? data.Total ?? 0,
    page: data.page ?? data.Page ?? page,
    pageSize: data.pageSize ?? data.PageSize ?? pageSize,
  };
}

export async function fetchGetRecetaProduccion(user: UserPayload, idProducto: number, idReceta: number, signal?: AbortSignal) {
  const response = await fetch(`${URLAPI}/Produccion/Receta/${idProducto}/${idReceta}`, {
    method: "GET",
    signal,
    headers: { "Authorization": "Bearer " + user.token },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const data = await response.json();
  return (data ?? []).map((item: any) => ({
    idProducto: item.idProducto ?? item.IdProducto ?? 0,
    codigo: item.codigo ?? item.Codigo ?? "",
    producto: item.producto ?? item.Producto ?? "",
    cantidad: Number(item.cantidad ?? item.Cantidad ?? 0),
    cantidadUnitario: Number(item.cantidad ?? item.Cantidad ?? 0),
    cantidadTotal: Number(item.cantidad ?? item.Cantidad ?? 0),
    costo: Number(item.costo ?? item.Costo ?? 0),
    observacion: "",
  })) as ProduccionInsumo[];
}

export async function fetchConfirmarProduccion(user: UserPayload, request: ConfirmarProduccionRequest) {
  const response = await fetch(`${URLAPI}/Produccion/Confirmar`, {
    method: "POST",
    headers: headers(user),
    body: JSON.stringify(request),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message ?? data?.Message ?? response.statusText);
  }

  return data;
}

export async function fetchCambiarSeProduce(user: UserPayload, idProducto: number, seProduce: boolean) {
  const response = await fetch(`${URLAPI}/Produccion/Producto/${idProducto}/SeProduce`, {
    method: "PATCH",
    headers: headers(user),
    body: JSON.stringify(seProduce),
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
}
